import { PaginatorContract, UrlRouteMap } from "@shared/services/api/types";
import Repository from "@shared/services/api/abstracts/Repository";
import { type PublicBaseEventSerializer } from "@app-contexts/public/features/event-detail/data/types/events";
import { UpcomingEventsRequestType } from "@app-contexts/public/features/org-profile/data/types/public-venue";
import {
  type ContactVenueParamsType,
  type GetCalendarEventsParamsType,
  type PublicCalendarEventSerializer,
  type PublicVenueSerializer,
} from "../../../../app-contexts/dashboard/features/venues/data/types/venues";

export default class PublicBasedVenuesRepository extends Repository<PublicVenueSerializer> {
  public readonly repositoryName = "PublicBasedVenuesRepository";

  public readonly endpoint = "api/public/venues/";

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      contact: "{id}/events/support",
      calendar: "{slug}/calendar",
      upcomingEvents: "{slug}/upcoming-events",
      paymentConfig: "{id}/payment-config",
    };
  }

  public async contact(params: ContactVenueParamsType): Promise<void> {
    const { data } = await this.request<void>(this.buildUrl("contact"), {
      data: params,
      method: "post",
    });
    return data;
  }

  public async calendar(
    params: GetCalendarEventsParamsType
  ): Promise<PaginatorContract<PublicCalendarEventSerializer>> {
    const url = this.buildUrl("calendar", { slug: params.slug });
    const { data } = await this.request<
      PaginatorContract<PublicCalendarEventSerializer>
    >(url, {
      method: "get",
      params,
    });
    return data;
  }

  public async upcomingEvents(
    slug: string,
    params: UpcomingEventsRequestType
  ): Promise<PublicBaseEventSerializer[]> {
    const url = this.buildUrl("upcomingEvents", { slug });
    const { data } = await this.request<PublicBaseEventSerializer[]>(url, {
      method: "get",
      params,
    });
    return data;
  }
}
